import { render, staticRenderFns } from "./CourseTransfers.vue?vue&type=template&id=458cbb88"
import script from "./CourseTransfers.vue?vue&type=script&lang=js"
export * from "./CourseTransfers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports